import type { App } from '@grafikr/components';
import type { JSX, ParentComponent } from 'solid-js';
import { createEffect, createSignal, Show, splitProps } from 'solid-js';

type Props = { app: App; url: RequestInfo | URL } & JSX.HTMLAttributes<HTMLDivElement>;

const LazyContent: ParentComponent<Props> = (props) => {
  const [{ app, url }, all] = splitProps(props, ['app', 'url', 'children']);
  const [output, setOutput] = createSignal<string>(null);

  createEffect(() => {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        setOutput(text);

        app.mount();
      });
  });

  return (
    <>
      <Show when={output()}>
        <div innerHTML={output()} />
      </Show>

      <Show when={!output()}>
        <div {...all}>{props.children}</div>
      </Show>
    </>
  );
};

export default LazyContent;
